import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col ml-3" }
const _hoisted_3 = { class: "timeline-content d-flex" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "card-header border-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Proses"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_follow_up",
  ref: "uploadModalRef"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_29 = { class: "modal-content rounded" }
const _hoisted_30 = { class: "modal-header pb-0 border-0 justify-content-center" }
const _hoisted_31 = {
  key: 0,
  class: "modal-title mb-6"
}
const _hoisted_32 = {
  key: 1,
  class: "modal-title mb-6"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_34 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-xl-6 mb-8" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_38 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "col-xl-6 mb-8" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_43 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-xl-6 mb-8" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_49 = { class: "col-xl-6 mb-8" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Proses", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Proses", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", {
  value: "true",
  key: "true"
}, "Sudah", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", {
  value: "false",
  key: "false"
}, "Belum", -1)
const _hoisted_54 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-success me-3",
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_follow_up",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tambahV()))
                }, " Tambah Follow Up ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _hoisted_11,
              (_ctx.data.tableDataFollowUp.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataFollowUp, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.progressDate), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.actorName), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.processed == true ? 'Sudah' : 'Belum'), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item.note.length > 50 ? item.note.substring(0, 50) + ' ...' : item.note), 1),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            title: "Edit",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.getId(index, item)),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#kt_modal_follow_up"
                          }, _hoisted_20, 8, _hoisted_18),
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            "data-bs-toggle": "tooltip",
                            title: "Hapus",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.handleDelete(index, item))
                          }, _hoisted_23, 8, _hoisted_21)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_24, _hoisted_26))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_ctx.items.aksi == 'tambah' )
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_31, " Tambah Follow Up "))
                  : (_openBlock(), _createElementBlock("h5", _hoisted_32, " Update Follow Up ")),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "actorName",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Penanggung Jawab",
                      modelValue: _ctx.tambahFollowUp.actorName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambahFollowUp.actorName) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.tambahFollowUp.actorName == '' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.items.erroractorName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40))
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "progressDate",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Tanggal",
                      modelValue: _ctx.tambahFollowUp.progressDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambahFollowUp.progressDate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.tambahFollowUp.progressDate == '' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.items.errorprogressDate), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45))
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Isi Catatan",
                      name: "note",
                      autocomplete: "off",
                      rows: "5",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tambahFollowUp.note) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.tambahFollowUp.note]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "processed",
                      autocomplete: "off",
                      modelValue: _ctx.tambahFollowUp.processed,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahFollowUp.processed) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_51,
                        _hoisted_52,
                        _hoisted_53
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.tambahFollowUp.processed == '' )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.items.errorprocessed), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_56))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.kosongkanVariabel()))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitFollowUp())),
                  disabled: _ctx.items.disableButton
                }, " Simpan ", 8, _hoisted_58)
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}